import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SafePipe } from '../../shared/pipe/safe.pipe';

@Component({
    selector: 'kn-br-paragraph',
    templateUrl: './kn-br-customer-title.component.html',
    styleUrls: ['./kn-br-customer-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, SafePipe]
})
export class KnBrCustomerTitleComponent implements OnInit {
  componentData$: Observable<CmsParagraphComponent> = this.componentData.data$;
  constructor(private componentData: CmsComponentData<CmsParagraphComponent>) {}
  ngOnInit(): void {}
}
